import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ShortcutDemonstration } from '../interfaces/chat-component.interfaces';

@Component({
  selector: 'app-welcome-state',
  templateUrl: './welcome-state.component.html',
  styleUrl: './welcome-state.component.scss'
})
export class WelcomeStateComponent {
  @Input() currentThreadId: string | null = null;
  @Input() loading: boolean = false;
  @Input() inFloatingPanel: boolean = false;
  @Input() contextUserObject: any = null;
  
  @Output() shortcutDemonstrated = new EventEmitter<ShortcutDemonstration>();
  @Output() starterPromptClicked = new EventEmitter<string>();

  demonstrateShortcut(type: 'agent' | 'context' | 'config' | 'prompts'): void {
    this.shortcutDemonstrated.emit({ type });
  }

  onStarterPromptClick(prompt: string): void {
    this.starterPromptClicked.emit(prompt);
  }
}
